module.exports = __webpack_public_path__ + "img/suspension-reminder-icon.3dca8640.svg";